export const content = {
    desktop: 1000,
    widescreen: 1300,
};
